module.exports = __webpack_public_path__ + "c3a89740144e3e453b0689a9b737fee0.MP3";